import React from 'react';
import { Package, Tag, Layers, Star, Award, Shield } from 'lucide-react';

const DefaultDetails = ({ listing }) => {
  const details = listing.specialized_data || {};
  
  // Don't render if it's a specialized type
  if (details._type && ['electronics', 'properties', 'services', 'vehicles'].includes(details._type)) {
    return null;
  }

  // Extract any available details
  const availableDetails = Object.entries(details)
    .filter(([key, value]) => key !== '_type' && key !== 'listing_id' && value)
    .map(([key, value]) => ({
      label: key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
      value: value
    }));

  if (availableDetails.length === 0) return null;

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 mb-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Product Details</h2>
      
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {availableDetails.map((detail, index) => {
          // Choose icon based on label
          let Icon = Package;
          const label = detail.label.toLowerCase();
          
          if (label.includes('brand') || label.includes('make')) Icon = Tag;
          else if (label.includes('model')) Icon = Layers;
          else if (label.includes('rating') || label.includes('quality')) Icon = Star;
          else if (label.includes('warranty') || label.includes('guarantee')) Icon = Shield;
          else if (label.includes('certificate') || label.includes('authentic')) Icon = Award;

          return (
            <div key={index} className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
              <div className="p-2 bg-white rounded-lg shadow-sm">
                <Icon className="w-5 h-5 text-gray-600" />
              </div>
              <div className="flex-1">
                <p className="text-sm text-gray-500">{detail.label}</p>
                <p className="font-medium text-gray-900">{detail.value}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DefaultDetails;